import { serviceRequest } from 'utils/http';
import { Service } from 'common/api';

export function getGetInvestigatorStudiesAPI() {
  return serviceRequest(() => Service.investigatorControllerGetInvestigatorStudies());
}
